export const apiUrls = {
  list: "/sessions",
};

export const path = "/listeners";
